import index from './'

export default [
  {
    props: true,
    path: 'role',
    name: 'role.index',
    component: index,
    meta: { requiresAuth: true , label : 'Grupo' }
  }
]



// WEBPACK FOOTER //
// ./src/features/Role/routes.js